import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { cn } from "@omni/utils/styles";
import { useMemo } from "react";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { getSortedFeatureKinds, hasDocuments } from "../helpers";

type NavigationProps = {
    product: Product<ProductFieldSet.Full>;
};

const Navigation = ({ product }: NavigationProps) => {
    const { t } = useGranite();

    const hasFeaturesResult = useMemo(() => {
        return (
            getSortedFeatureKinds(product, t)
                .filter((f) => !!f.name)
                .map((f) => f.name).length > 0
        );
    }, [product, t]);

    const hasDocumentsResult = useMemo(() => {
        return hasDocuments(product);
    }, [product]);

    return (
        <nav
            className={cn(
                "tw:bg-background tw:layer-base/[1] tw:border-b tw:border-b-grey-light tw:border-solid tw:sticky tw:top-0 tw:my-6 tw:hidden! tw:lg:flex! tw:gap-8"
            )}
        >
            <Anchor
                href={`#${t("productDetail.anchor.hash.description")}`}
                color={"link"}
                className={cn("tw:block tw:py-2 tw:px-0 js-anchor-scroll-spy")}
            >
                {t("productDetail.anchor.title.description")}
            </Anchor>
            {hasFeaturesResult && (
                <Anchor
                    href={`#${t("productDetail.anchor.hash.features")}`}
                    color={"link"}
                    className={cn(
                        "tw:block tw:py-2 tw:px-0 js-anchor-scroll-spy"
                    )}
                >
                    {t("productDetail.anchor.title.features")}
                </Anchor>
            )}
            {hasDocumentsResult && (
                <Anchor
                    href={`#${t("productDetail.anchor.hash.documentation")}`}
                    color={"link"}
                    className={cn(
                        "tw:block tw:py-2 tw:px-0 js-anchor-scroll-spy"
                    )}
                >
                    {t("productDetail.anchor.title.documentation")}
                </Anchor>
            )}
        </nav>
    );
};

export { Navigation };
